export const RecruitmentSourcing = {
    path: '/recruitment_sourcings',
    name: 'recruitment_sourcings',
    component: () => import('@/views/Recruitment/Sourcing/SourcingPage.vue'),
    children: [
        {
            path: '/recruitment_sourcings/view/:id',
            name: 'recruitment_sourcings.view',
            component: () => import('@/views/Request/RecruitmentRequest/Form/RecruitmentRequestForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/recruitment_sourcings/lock/:id',
            name: 'recruitment_sourcings.lock',
            component: () => import('@/views/Recruitment/Sourcing/Form/LockAndUnlockForm.vue'),
            props: {lockAction: true}
        },
        {
            path: '/recruitment_sourcings/unlock/:id',
            name: 'recruitment_sourcings.unlock',
            component: () => import('@/views/Recruitment/Sourcing/Form/LockAndUnlockForm.vue'),
            props: {unlockAction: true}
        },
        {
            path: '/recruitment_sourcings/share/:id',
            name: 'recruitment_sourcings.share',
            component: () => import('@/views/Recruitment/Sourcing/Form/ShareForm.vue'),
        },
        {
            path: '/recruitment_sourcings/planning/add/:id',
            name: 'recruitment_sourcings.planning.add',
            component: () => import('@/views/Recruitment/Planning/Form/PlanningForm.vue'),
            props: {addAction: true},
            children: [
                {
                    path: '/recruitment_plannings/cv_techs/view/:id',
                    name: 'recruitment_plannings.add.cv_techs.view',
                    component: () => import('@/views/Recruitment/CvTech/Form/CvTechForm.vue'),
                },
            ],
        },
    ],
}

export const RecruitmentSourcingAdd = {
    path: '/recruitment_sourcings/add/:id',
    name: 'recruitment_sourcings.add',
    component: () => import('@/views/Recruitment/Sourcing/Form/SourcingForm.vue'),
    props: {addAction: true},
    children: [
        {
            path: '/recruitment_sourcings/cv_techs/view/:id',
            name: 'recruitment_sourcings.cv_techs.view',
            component: () => import('@/views/Recruitment/CvTech/Form/CvTechForm.vue'),
        },
        {
            path: '/evaluation_recruitment_sourcings/interview/view/:id',
            name: 'evaluation_recruitment_sourcings.interview.view',
            component: () => import('@/views/Evaluation/EvaluationInterview/Form/EvaluationRecruitmentInterviewForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/recruitment_sourcings/filter/:id',
            name: 'recruitment_sourcings.filter',
            component: () => import('@/views/Request/RecruitmentRequest/Form/RecruitmentRequestFilteringForm.vue'),
            props: {viewAction: true}
        }
    ],
}